import { NativeStackScreenProps } from '@react-navigation/native-stack';

export interface NewAccountModalProps {
  onLayout: (event: any) => void;
}

export enum NewAccountStackRoutes {
  Main = 'main',
  Confirm = 'confirm',
  Placed = 'placed'
}

export type NewAccountStackParamList = {
  [NewAccountStackRoutes.Main]: NewAccountModalProps & {
    onData: (data: any) => void;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
    onChangeView?: () => void;
  };
  [NewAccountStackRoutes.Confirm]: NewAccountModalProps & {
    data: any;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
    onChangeView?: () => void;
  };
  [NewAccountStackRoutes.Placed]: NewAccountModalProps & {
    data?: any;
    returnData?: any;
    refresh?: () => void;
  };
};

export type NewAccountStackScreenProps<Screen extends keyof NewAccountStackParamList> = NativeStackScreenProps<
  NewAccountStackParamList,
  Screen
>;
